// Time to wait for a connection to close gracefully before destroying it manually
export const CLOSE_TIMEOUT = 500;
//# sourceMappingURL=constants.js.map